/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Support_Title7Inputs */

const en_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 days post-launch support`)
};

const ar_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دعم 14 يوما بعد الإطلاق`)
};

const bn_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লঞ্চের পর ১৪ দিন সাপোর্ট`)
};

const de_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 Tage Support nach dem Start`)
};

const es_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 días de soporte tras el lanzamiento`)
};

const fr_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 jours de support après le lancement`)
};

const pt_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 dias de suporte após o lançamento`)
};

const zh_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上线后 14 天支持`)
};

const tr_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansman sonrası 14 gün destek`)
};

const ru_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 дней поддержки после запуска`)
};

const pl_svc_mvp_sprint_support_title7 = /** @type {(inputs: Svc_Mvp_Sprint_Support_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 dni wsparcia po starcie`)
};

/**
* | output |
* | --- |
* | "14 days post-launch support" |
*
* @param {Svc_Mvp_Sprint_Support_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_support_title7 = /** @type {((inputs?: Svc_Mvp_Sprint_Support_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Support_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_support_title7(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_support_title7(inputs)
	if (locale === "de") return de_svc_mvp_sprint_support_title7(inputs)
	if (locale === "es") return es_svc_mvp_sprint_support_title7(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_support_title7(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_support_title7(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_support_title7(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_support_title7(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_support_title7(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_support_title7(inputs)
	return en_svc_mvp_sprint_support_title7(inputs)
});
export { svc_mvp_sprint_support_title7 as "svc_mvp-sprint_SUPPORT_title" }